<div class="l-core-contents-float js-core-contents-float seatmap-floating-navi">
  <!-- [コンテンツ領域 下部固定エリア内機能ボタンエリア] -->

  <div class="p-core-contents-float-function01">
    <div class="p-core-contents-float-function01__col">
      <!-- チャイルドシート選択モーダルを開くボタン -->
      <div class="p-core-contents-float-function01__item p-core-contents-float-function01__item--left01">
        <asw-servicing-seatmap-open-child-seat-selection-modal-button
          [travelersMap]="travelersMap"
          [numberOfChildSeats]="numberOfChildSeats"
          [selectingPassengerId]="selectingPassengerId"
          (clickBringChildSeat)="onClickBringChildSeat()"
        ></asw-servicing-seatmap-open-child-seat-selection-modal-button>
      </div>
    </div>

    <!-- シートマップレイアウト詳細モーダルを開くボタン -->
    <!-- SP版の場合、下に記述してあるシートプロダクト情報モーダルを開くボタンが非表示の際に、右に詰めるようにする -->
    <div class="p-core-contents-float-function01__col">
      <ng-container *aswIfScreenSize="'SP'">
        <div
          class="p-core-contents-float-function01__item"
          [class.p-core-contents-float-function01__item--right02]="!isLayoutDetailDisplay() || !normalSeatImageExist"
          [class.p-core-contents-float-function01__item--right03]="isLayoutDetailDisplay() && normalSeatImageExist"
          *ngIf="isLayoutDetailDisplay()"
        >
          <button
            id="open-seatmap-layout-detail-modal-button-sp"
            class="p-core-contents-float-function01__btn p-core-contents-float-function01__btn--icon"
            aswThrottleClick
            (throttleClick$)="onClickLayoutDetail()"
          >
            <img
              src="assets/images/seatmap_float_detail.svg"
              width="40"
              height="40"
              alt="{{ 'm_static_message-reader.displayAircraftLayoutDetailModal' | staticMsg }}"
            />
          </button>
        </div>
      </ng-container>
      <ng-container *aswIfScreenSize="['TAB', 'PC']">
        <div
          class="p-core-contents-float-function01__item p-core-contents-float-function01__item--right03"
          *ngIf="isLayoutDetailDisplay()"
        >
          <button
            id="open-seatmap-layout-detail-modal-button-not-sp"
            class="p-core-contents-float-function01__btn p-core-contents-float-function01__btn--icon"
            aswThrottleClick
            (throttleClick$)="onClickLayoutDetail()"
          >
            <img
              src="assets/images/seatmap_float_detail.svg"
              width="40"
              height="40"
              alt="{{ 'm_static_message-reader.displayAircraftLayoutDetailModal' | staticMsg }}"
            />
          </button>
        </div>
      </ng-container>

      <!-- シートプロダクト情報モーダルを開くボタン -->
      <ng-container *aswIfScreenSize="'SP'">
        <div
          class="p-core-contents-float-function01__item p-core-contents-float-function01__item--right02"
          *ngIf="isSeatProductDisplay()"
        >
          <button
            id="open-seat-product-modal-button"
            class="p-core-contents-float-function01__btn p-core-contents-float-function01__btn--icon"
            aswThrottleClick
            (throttleClick$)="onClickSeatType()"
          >
            <img
              src="assets/images/seatmap_float_seattype.svg"
              width="40"
              height="40"
              alt="{{ 'm_static_message-reader.displaySeatTypeModal' | staticMsg }}"
            />
          </button>
        </div>
      </ng-container>

      <!-- 凡例モーダルを開くボタン -->
      <ng-container *aswIfScreenSize="['SP', 'TAB']">
        <div class="p-core-contents-float-function01__item p-core-contents-float-function01__item--right01">
          <button
            id="open-legend-modal-button"
            class="p-core-contents-float-function01__btn p-core-contents-float-function01__btn--icon"
            aswThrottleClick
            (throttleClick$)="onClickLegend()"
          >
            <img
              src="assets/images/seatmap_float_legend.svg"
              width="40"
              height="40"
              alt="{{ 'm_static_message-label.legend1' | staticMsg }}"
            />
          </button>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- //[コンテンツ領域 下部固定エリア内機能ボタンエリア] -->
</div>
